import { render, staticRenderFns } from "./MonthlyViews.vue?vue&type=template&id=0da73574&scoped=true&"
import script from "./MonthlyViews.vue?vue&type=script&lang=js&"
export * from "./MonthlyViews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da73574",
  null
  
)

export default component.exports